import React from 'react'
import { Modal, message } from 'antd'
import { supplyRequest } from './calendar/api'

export const useSupplyTrash = (onChange: () => void) => {
  const [modal, modalContext] = Modal.useModal()
  const [notice, noticeContext] = message.useMessage()
  const change = (input: { kind: 'job' | 'document'; id: string; name: string; restore?: boolean }) => {
    const perform = async () => {
      try {
        const base = input.kind === 'job' ? `/api/supply/processing/jobs/${input.id}` : `/api/supply/incoming-documents/${input.id}`
        await supplyRequest(`${base}/${input.restore ? 'restore' : 'delete'}`, { method: 'POST', body: '{}' })
        notice.success(input.restore ? 'Восстановлено' : 'Перемещено в корзину')
        onChange()
      } catch (error: any) { notice.error(error.message); throw error }
    }
    if (input.restore) { void perform().catch(() => {}); return }
    modal.confirm({ title: input.kind === 'job' ? 'Удалить загрузку?' : 'Удалить накладную?',
      content: <><p>{input.name}</p><p>{input.kind === 'job' ? 'Разбор будет остановлен. Загрузка и её накладные переместятся в корзину.' : 'Накладная исчезнет из списка входящих и календаря.'} Восстановить её можно из корзины. Документы в 1С не изменятся.</p></>,
      okText: 'В корзину', cancelText: 'Отмена', okButtonProps: { danger: true }, onOk: perform })
  }
  return { change, contextHolder: <>{modalContext}{noticeContext}</> }
}
